import { AvailabilityConfigurationForPractitionerQuery } from '@dreryk/egabinet-appointment-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { useCqrsGet, UseCqrsQueryResult } from '@dreryk/command-query-react-common';

export const useCqrsGetAvailabilityConfigurationForPractitioner = (
   practitionerId: PractitionerId
): UseCqrsQueryResult<boolean> => {
   return useCqrsGet<boolean>(() => {
      const availabilityConfigurationForDoctorQuery = new AvailabilityConfigurationForPractitionerQuery();
      availabilityConfigurationForDoctorQuery.practitionerId = practitionerId;
      return availabilityConfigurationForDoctorQuery;
   });
};
